import { __assign } from "tslib";
import React from 'react';
import { Tag } from '@chakra-ui/react';
export function UTag(props) {
    return (React.createElement(Tag, __assign({ minWidth: "8.5em", alignContent: "right", borderStyle: "solid", borderWidth: "thick", borderTop: "none", borderTopLeftRadius: "none", borderTopRightRadius: "none", borderBottomLeftRadius: "xl", borderBottomRightRadius: "xl" }, props)));
}
